// extracted by mini-css-extract-plugin
export var danger = "_3y-6";
export var lightPink = "_3y-a";
export var medium = "_3y-j";
export var nearSquare = "_3y-m";
export var neutralBlue = "_3y-8";
export var neutralYellow = "_3y-7";
export var noCapitalize = "_3y-1";
export var normal = "_3y-2";
export var pill = "_3y-0";
export var primary = "_3y-3";
export var primaryLight = "_3y-4";
export var shadow = "_3y-n";
export var small = "_3y-k";
export var solidBlack = "_3y-i";
export var solidGreen = "_3y-d";
export var solidLightBlue = "_3y-f";
export var solidNavy = "_3y-e";
export var solidOrange = "_3y-h";
export var solidPink = "_3y-g";
export var solidRed = "_3y-b";
export var solidWhite = "_3y-9";
export var solidYellow = "_3y-c";
export var success = "_3y-5";
export var xsmall = "_3y-l";